
export function Fullscreen() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      style={{ color: 'currentColor' }}
    >
      <path d="M2 2h7v2H4v5H2V2zM22 2v7h-2V4h-5V2h7zM22 22h-7v-2h5v-5h2v7zM2 22v-7h2v5h5v2H2z"/>
    </svg>
  );
}
